"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZoneTypes = exports.UnitTypes = exports.SoldierTypes = exports.EnvConfig = exports.AchievementTypes = exports.reducer = undefined;

var _achievementTypes = require("./achievement-types");

var AchievementTypes = _interopRequireWildcard(_achievementTypes);

var _envConfig = require("./env-config");

var EnvConfig = _interopRequireWildcard(_envConfig);

var _soldierTypes = require("./soldier-types");

var SoldierTypes = _interopRequireWildcard(_soldierTypes);

var _unitTypes = require("./unit-types");

var UnitTypes = _interopRequireWildcard(_unitTypes);

var _zoneTypes = require("./zone-types");

var ZoneTypes = _interopRequireWildcard(_zoneTypes);

var _redux = require("redux");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var reducer = exports.reducer = (0, _redux.combineReducers)({
  achievementTypes: AchievementTypes.reducer,
  envConfig: EnvConfig.reducer,
  soldierTypes: SoldierTypes.reducer,
  unitTypes: UnitTypes.reducer,
  zoneTypes: ZoneTypes.reducer
});
exports.AchievementTypes = AchievementTypes;
exports.EnvConfig = EnvConfig;
exports.SoldierTypes = SoldierTypes;
exports.UnitTypes = UnitTypes;
exports.ZoneTypes = ZoneTypes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZW50aXRpZXMyL2luZGV4LmpzIl0sIm5hbWVzIjpbIkFjaGlldmVtZW50VHlwZXMiLCJFbnZDb25maWciLCJTb2xkaWVyVHlwZXMiLCJVbml0VHlwZXMiLCJab25lVHlwZXMiLCJyZWR1Y2VyIiwiYWNoaWV2ZW1lbnRUeXBlcyIsImVudkNvbmZpZyIsInNvbGRpZXJUeXBlcyIsInVuaXRUeXBlcyIsInpvbmVUeXBlcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOztJQUFZQSxnQjs7QUFDWjs7SUFBWUMsUzs7QUFDWjs7SUFBWUMsWTs7QUFDWjs7SUFBWUMsUzs7QUFDWjs7SUFBWUMsUzs7QUFDWjs7OztBQVNPLElBQU1DLDRCQUFVLDRCQUFnQjtBQUNyQ0Msb0JBQWtCTixpQkFBaUJLLE9BREU7QUFFckNFLGFBQVdOLFVBQVVJLE9BRmdCO0FBR3JDRyxnQkFBY04sYUFBYUcsT0FIVTtBQUlyQ0ksYUFBV04sVUFBVUUsT0FKZ0I7QUFLckNLLGFBQVdOLFVBQVVDO0FBTGdCLENBQWhCLENBQWhCO1FBT0NMLGdCLEdBQUFBLGdCO1FBQWtCQyxTLEdBQUFBLFM7UUFBV0MsWSxHQUFBQSxZO1FBQWNDLFMsR0FBQUEsUztRQUFXQyxTLEdBQUFBLFMiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0ICogYXMgQWNoaWV2ZW1lbnRUeXBlcyBmcm9tIFwiLi9hY2hpZXZlbWVudC10eXBlc1wiXG5pbXBvcnQgKiBhcyBFbnZDb25maWcgZnJvbSBcIi4vZW52LWNvbmZpZ1wiXG5pbXBvcnQgKiBhcyBTb2xkaWVyVHlwZXMgZnJvbSBcIi4vc29sZGllci10eXBlc1wiXG5pbXBvcnQgKiBhcyBVbml0VHlwZXMgZnJvbSBcIi4vdW5pdC10eXBlc1wiXG5pbXBvcnQgKiBhcyBab25lVHlwZXMgZnJvbSBcIi4vem9uZS10eXBlc1wiXG5pbXBvcnQge2NvbWJpbmVSZWR1Y2Vyc30gZnJvbSBcInJlZHV4XCJcblxuZXhwb3J0IHR5cGUgU3RhdGUgPSB7fFxuICArYWNoaWV2ZW1lbnRUeXBlczogQWNoaWV2ZW1lbnRUeXBlcy5TdGF0ZSxcbiAgK2VudkNvbmZpZzogRW52Q29uZmlnLlN0YXRlLFxuICArc29sZGllclR5cGVzOiBTb2xkaWVyVHlwZXMuU3RhdGUsXG4gICt1bml0VHlwZXM6IFVuaXRUeXBlcy5TdGF0ZSxcbiAgK3pvbmVUeXBlczogWm9uZVR5cGVzLlN0YXRlLFxufH1cbmV4cG9ydCBjb25zdCByZWR1Y2VyID0gY29tYmluZVJlZHVjZXJzKHtcbiAgYWNoaWV2ZW1lbnRUeXBlczogQWNoaWV2ZW1lbnRUeXBlcy5yZWR1Y2VyLFxuICBlbnZDb25maWc6IEVudkNvbmZpZy5yZWR1Y2VyLFxuICBzb2xkaWVyVHlwZXM6IFNvbGRpZXJUeXBlcy5yZWR1Y2VyLFxuICB1bml0VHlwZXM6IFVuaXRUeXBlcy5yZWR1Y2VyLFxuICB6b25lVHlwZXM6IFpvbmVUeXBlcy5yZWR1Y2VyLFxufSlcbmV4cG9ydCB7QWNoaWV2ZW1lbnRUeXBlcywgRW52Q29uZmlnLCBTb2xkaWVyVHlwZXMsIFVuaXRUeXBlcywgWm9uZVR5cGVzfVxuIl19


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/entities2/index.js
// module id = 813
// module chunks = 0